import { render, staticRenderFns } from "./AccountHolderExpenseSubmission.vue?vue&type=template&id=c7e6f95e&scoped=true"
import script from "./AccountHolderExpenseSubmission.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseSubmission.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenseSubmission.vue?vue&type=style&index=0&id=c7e6f95e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e6f95e",
  null
  
)

export default component.exports